/* eslint-disable no-console */
import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class PdpVariantTable extends ThemeComponent {

    @Ref() variantTable!: HTMLElement[];
    @Ref() initialTable!: HTMLElement;

    init() {
        const variantSelector = document.querySelector('.single-option-selector');
        let currentLocation = document.location.href;

        this.checkLoadedTable();

        const observer = new MutationObserver((mutationList) => {
            if (currentLocation !== document.location.href) {
                // location changed!
                currentLocation = document.location.href;
                this.showVariantTable();
            }
        });

        const target = document.querySelector('.price-ui');
        if (!target) {return;}
        observer.observe(target,{childList: true, subtree: false});
    }

    checkLoadedTable() {
        const currentUrl = window.location.search;
        const variantId = currentUrl.replace('?variant=', '');

    }

    showVariantTable() {
        const currentUrl = window.location.search;
        const variantId = currentUrl.replace('?variant=', '');

        this.initialTable.classList.add('hidden');

        for (const table of this.variantTable) {
            const tableId = table.dataset.id;

            if(tableId === variantId) {
                table.classList.remove('hidden');
            } else {
                table.classList.add('hidden');
            }
        }

    }

}
